module.exports = __webpack_public_path__ + "img/PPMP26.a71aeff2.png";